import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import "./modal-alert.css"

export const ModalAlert = (message, title, buttonText) => {
    const MySwal = withReactContent(Swal);
    MySwal.mixin({
        customClass: {
            confirmButton: 'btn btn-primary finaBtnStyle'
        },
        buttonsStyling: false
    }).fire({
        title: title,
        showCloseButton: true,
        icon: 'error',
        html: message,
        confirmButtonText: buttonText,
        onOpen: () => {
            document.getElementById("swal2-title").setAttribute("lang", "hr")
            document.getElementById("swal2-content").setAttribute("lang", "hr")
            document.getElementsByClassName("finaBtnStyle")[0].setAttribute("lang", "hr")
        }
    });
};